// extracted by mini-css-extract-plugin
module.exports = {"container":"gHVApIFhDPNKhrigX499W","question":"dqJ5JAs8FaQc8szsPuKoM","buttons":"_3tvpVQu3DN1WWmnXsaulF4"};